import { Component, OnInit } from '@angular/core';
import { PreloaderService } from '@sharedServices/preloader.service';
import { delay } from 'rxjs/operators';
import { Title } from '@angular/platform-browser';
import { environment } from '@environment';
import moment from 'moment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {

  isPreLoading: boolean = false;

  constructor(
    private _preloaderService: PreloaderService,
    private titleService: Title
  ) {}

  ngOnInit(): void {
    moment.suppressDeprecationWarnings = true
    this.listenToLoading();
    this.titleService.setTitle(`Affordplan® WebApp | ${environment.appVersion}`);
  }

  listenToLoading(): void {
    this._preloaderService.loadingSub
      .pipe(delay(0))
      .subscribe((loading) => {
        this.isPreLoading = loading;
      });
  }
}
